import React from "react";
import {
  Box,
  Select,
  MenuItem,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { theme } from "../../Assets/Theme/theme";

const Dropdown = ({
  label,
  placeholder,
  value,
  onChange,
  options,
  startIcon,
  endIcon,
  name,
  bgColor,
  padding,
  height,
  border,
  experience,
  images,
  marginBottom,
  inputHeight,
  labelHeading,
  ...props
}) => {
  const displayValue = value === undefined ? "" : value;

  return (
    <Box sx={{ mb: marginBottom ? marginBottom : 2 }}>
      {label && (
        <Typography
          variant="body1"
          sx={{
            fontWeight: "700",
            mb: 1,
            color: theme.colors.text,
            fontSize: labelHeading ? "16px" : "20px",
          }}
        >
          {label}
        </Typography>
      )}

      <Select
        value={displayValue || ""}
        onChange={onChange}
        displayEmpty
        fullWidth
        name={name}
        {...props}
        startAdornment={
          startIcon && (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          )
        }
        endAdornment={
          endIcon && (
            <InputAdornment position="end">
              <IconButton edge="end">{endIcon}</IconButton>
            </InputAdornment>
          )
        }
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: height,
              overflowY: "auto",
            },
          },
        }}
        sx={{
          background: bgColor || "#f9f9f9",
          borderRadius: "8px",
          "& .MuiSelect-select": {
            padding: padding ? padding : "16px",
            height: inputHeight ? inputHeight : "20px",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: border ? "#FFF" : "#ccc",
            },
            "&:hover fieldset": {
              borderColor: border ? "#FFF" : "#ccc",
            },
            "&.Mui-focused fieldset": {
              borderColor: border ? "#FFF" : "#ccc",
              borderWidth: border ? "0px" : "2px",
              outline: "#ccc",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: border ? "#FFF" : "#ccc",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: border ? "#FFF" : "#ccc",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: border ? "#FFF" : "#ccc",
          },
          color: "#121212",
          fontWeight: "700",
          fontSize: "14px",
          paddingTop: "2px"
        }}
      >
        {/* Placeholder */}
        <MenuItem value="" disabled sx={{ mt: 1 }}>
          <em>{placeholder || "Select an option"}</em>
        </MenuItem>
        {images && options
          ? options.map((option, index) => (
              <MenuItem key={index} value={option.value}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px", 
                  }}
                >
                  <img
                    src={option.image}
                    alt={option.label}
                    style={{
                      width: "20px",
                      height: "20px",
                      objectFit: "contain",
                    }}
                  />
                  <span>{option.label}</span>
                </div>
              </MenuItem>
            ))
          : options.map((option, index) => (
              <MenuItem key={index} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
      </Select>
    </Box>
  );
};

export default Dropdown;
